import { defineComponent } from 'vue';
import { IAlertNotification } from '@/api/klip-api.proxy';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlHeaderMessage',
    emits: ['message-closed'],
    props: {
        messages: {
            type: Array<IAlertNotification>,
            default: "",
            required: true
        }
    },
    setup(props, { emit }) {
        const closeMessage = async (messageId: string) => {
            emit('message-closed', messageId);
        };

        const getAlertModifiers = (message: IAlertNotification) => ({
            'mod-info': message.type === 'mod-info',
            'mod-warning': message.type === 'mod-warning'
        });

        return {
            closeMessage,
            getAlertModifiers
        };

    }
});
